// Wrap
// TODO: doesn't take into account wild wraparounds, e.g. -90000 for (-180,180).
export default function (number, min, max) {
	if (number < min) {
		const diff = min - number;
		return max + diff;
	}
	if (number > max) {
		const diff = max - number;
		return min - diff;
	}
	return number;
}
